export default {
    ca: {
        title: 'Recuperar contrasenya',
        hasOblidat: 'Has oblidat la teva contrasenya?',
        recuperarPssw: 'Recuperar contrasenya',
        emailValidation: 'L\'email és obligatori i ha de ser vàlid',
        emailPlaceholder: 'Escriu el correu amb el que et vas enregistrar',
        titleErrorRemember: 'Error recuperar contrasenya',
        messageErrorRemember: 'L\'usuari no existeix',
        titleOkRemember: 'S\'ha recuperat la contrasenya',
        messageOkRemember: 'La teva petició s\'ha processat. Si no trobes el correu que t\'hem enviat, revisa la teva carpeta de correu no desitjat',
        notaRecuperarPsw: 'Si no rebeu cap correu de recordatori de contrasenya, proveu a recuperar-la mitjançant el següent ',
        enllacRecuperarPsw: 'enllaç.',
    },
    es: {
        title: 'Recuperar contraseña',
        hasOblidat: '¿Has olvidado tu contraseña?',
        recuperarPssw: 'Recuperar contraseña',
        emailValidation: 'El email es obligatorio y debe ser válido',
        emailPlaceholder: 'Escribe el correo con el que te registraste',
        titleErrorRemember: 'Error recuperar contraseña',
        messageErrorRemember: 'El usuario no existe',
        titleOkRemember: 'Se ha recuperado la contraseña',
        messageOkRemember: 'Tu petición se ha procesado. Si no encuentras el correo que te hemos enviado, revisa tu carpeta de correo no deseado',
        notaRecuperarPsw: 'Si no recibes ningún correo de recordatorio de contraseña, puedes probar a recuperarla mediante el siguiente ',
        enllacRecuperarPsw: 'enlace.',
    },
    en: {
        title: 'Retrieve password',
        hasOblidat: 'Forgot your password?',
        recuperarPssw: 'Retrieve password',
        emailValidation: 'Email is mandatory and must be valid',
        emailPlaceholder: 'Write the email with which you registered',
        titleErrorRemember: 'Error retrieving password',
        messageErrorRemember: 'The user does not exist',
        titleOkRemember: 'Password recovered',
        messageOkRemember: 'Your request has been processed. If you can not find the email we sent you, check your spam folder',
        notaRecuperarPsw: 'If you do not receive any password reminder email, try retrieving it with the following ',
        enllacRecuperarPsw: 'link.',
    },
};



// WEBPACK FOOTER //
// ./src/oblidat/oblidat-translations.js